webpackJsonp([6],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(34);

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42ade86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_echoes_md__ = __webpack_require__(35);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42ade86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_echoes_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('html',[_c('head'),_c('body',[_c('h1',[_vm._v("Echoes")]),_vm._v(" "),_c('p',[_vm._v("Maybe we could have been something "),_c('br'),_vm._v("\nBut I guess we'll never know now "),_c('br'),_vm._v("\nBecause it all broke down  "),_c('br'),_vm._v("\nHalted by echoes")]),_vm._v(" "),_c('p',[_vm._v("I tell you that you're beautiful  "),_c('br'),_vm._v("\nYou tell me "),_c('br'),_vm._v("\n\"I'm already in your bed "),_c('br'),_vm._v("\nYou don't need to keep trying\" "),_c('br'),_vm._v("\nBut all I hear is her "),_c('br'),_vm._v("\nI hear "),_c('br'),_vm._v("\n\"You've got an ulterior motive\" or "),_c('br'),_vm._v("\n\"You're only being affectionate  "),_c('br'),_vm._v("\nBecause you're hiding something\"")]),_vm._v(" "),_c('p',[_vm._v("In our non-exclusivity "),_c('br'),_vm._v("\nYou were never shy about your escapades "),_c('br'),_vm._v("\nYet you get the slightest hint  "),_c('br'),_vm._v("\nThat I find someone else attractive  "),_c('br'),_vm._v("\nAnd you put your nose up "),_c('br'),_vm._v("\nYou switch on the silence and walk away "),_c('br'),_vm._v("\nYou play it off as a joke later "),_c('br'),_vm._v("\nBut it started as a joke with her too "),_c('br'),_vm._v("\nAnd it puts me right back "),_c('br'),_vm._v("\nTo the day that I left "),_c('br'),_vm._v("\nWhen that woman crossed my line of sight "),_c('br'),_vm._v("\nI didn't give her a second look "),_c('br'),_vm._v("\nI didn't even give her a first look "),_c('br'),_vm._v("\nBut I was facing the wrong direction "),_c('br'),_vm._v("\nAnd now I'm the bad guy "),_c('br'),_vm._v("\nNot by my actions but by her insecurities")]),_vm._v(" "),_c('p',[_vm._v("I know you're not her "),_c('br'),_vm._v("\nI don't believe that you would be capable "),_c('br'),_vm._v("\nCapable of the things she's done "),_c('br'),_vm._v("\nBut I didn't think that she was either "),_c('br'),_vm._v("\nShe didn't trust my kindness "),_c('br'),_vm._v("\nAnd neither do you "),_c('br'),_vm._v("\nLike you she allowed insecurities  "),_c('br'),_vm._v("\nShape her view of my reality "),_c('br'),_vm._v("\nAnd maybe I am too "),_c('br'),_vm._v("\nMaybe I'm seeing red flags "),_c('br'),_vm._v("\nWhere I shouldn't  "),_c('br'),_vm._v("\nBut too often I'm reminded "),_c('br'),_vm._v("\nToo often I hear the echo "),_c('br'),_vm._v("\nThe echo of her voice on your tongue "),_c('br'),_vm._v("\nIt's an echo I can't ignore")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.3bf40806eda17af15f60.js